import { render, staticRenderFns } from "./ParticipationROI.vue?vue&type=template&id=654d0f5e&scoped=true"
import script from "./ParticipationROI.vue?vue&type=script&lang=js"
export * from "./ParticipationROI.vue?vue&type=script&lang=js"
import style0 from "./ParticipationROI.vue?vue&type=style&index=0&id=654d0f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d0f5e",
  null
  
)

export default component.exports